module.exports = __webpack_public_path__ + "img/14.49ad558c.jpg";